import React from "react";
import {ArrowBackCircle, ArrowForwardCircle, ArrowDownCircle, TrashOutline} from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import {Modal} from 'react-bootstrap';
import constantURI from "../URI"
import _post from "../Functions/NoBodyPost";
import _postBody from "../Functions/Post";
import WMSAuthenticate from "../Functions/WMSAuthenticate"
import DeliveryForm from "./DeliveryForm"
import stylesWMS from "./stylesWMS";
import stylesMed from "../MedRep/stylesMed";
import stylesASAP from "../ASAP/stylesASAP";
import {FaCheck} from 'react-icons/fa';
import ReactToPrint from 'react-to-print';
import wrong from '../wrong.mp3';
import {db, collection, getDocs, getDoc, setDoc, doc} from '../firebase';

export default class Transaction extends React.Component {

    constructor() {
        super();
        this.state = {
            items: [],
            itemsCopy: [],
            itemIndex: 0,
            bar: "",
            barText: "",
            authenticate: false,
            token: "",
            task: [],
            loading: true,
            noData: true,
            orderLines: [],
            orderLinesCopy: [],
            order: [],
            show: [],
            categories: [],
            showDeleteAlert: false,
            selectedIndex: -1,
            itemsHeader: [{"name": "Barcode"}, {"name": "Name"}, {"name": "Qty"}, {"name": "PackNb"}, {"name": "Delete"}],
            fixedName: "",
            preventSymbols: ["e", "E", "+", "-", "."],
            disableSave: false,
            transferId: 0,
            showSourceAlert: false,
            source: "",
            locations: [],
            SML: [],
            packages: [],
            Hold: [],
            interface: 0,
            transactionType: [{"name": "/Request"}, {"name": "/Transfer"}],
            selectedType: -1,
            specificSelectedType: 0,
            title: "",
            stage: "",
            module: -1,
            disableScan: false,
            addedItems: [],
            counter: 1,
            barcode: "0000000000000",
            remark: "This item is added although it was not ordered.",
            allCategoryProducts: [],
            productCategory: [],
            packagesCategory: [],
            interval: 0,
            username: "",
        }
        this.ref = React.createRef();
        this.audioWrong = new Audio(wrong);
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";
        const user = JSON.parse(localStorage.getItem("Username"));
        this.setState({username: user});
        // Start the interval and store the ID to shold the data
        const interval = setInterval(() => {
            console.log("HI");
            this.onHold();
        }, 100000);
        this.setState({interval: interval});
        console.log(this.state.interval);
        //Setting the transaction type
        await this.state.transactionType.map((item, index) => {
            if (this.props.history.location.pathname === item.name) {
                this.setState({selectedType: index});
            }
        });
        //Setting the transaction based on selected module
        const title = JSON.parse(localStorage.getItem("Title"));
        if (title[0] === 4) {
            this.setState({transaction: 0}); //WMS
        } else if (title[0] === 5) {
            this.setState({transaction: 1}); //OMS
        }

        if (this.state.transaction === 0) {
            this.compWMS();
        } else {
            this.compOMS();
        }
    }

    stopInterval = () => {
        // Stop the interval using clearInterval
        clearInterval(this.state.interval);
    };

    compOMS = async () => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        const token = JSON.parse(localStorage.getItem("Token"));
        const orderLines = JSON.parse(localStorage.getItem("TransactionLines"));
        const order = JSON.parse(localStorage.getItem("Transaction"));
        const module = JSON.parse(localStorage.getItem("Interface"));
        const locations = JSON.parse(localStorage.getItem("Locations"));
        const Items = JSON.parse(localStorage.getItem("HoldOMS"));
        //If user is packaging
        if (module === 1) {
            this.setState({title: "Pick & Pack", selectedType: 1, stage: "Shipped", module: module});
        }
        //If user is driver(ships to warehouse)
        else if (module === 2) {
            this.setState({title: "Packages", stage: "Landed", module: module});
        }
        //If user is driver (ships to client)
        else if (module === 3) {
            this.setState({title: "Packages", stage: "Repackaged", module: module});
        }
        if (Items !== null) {
            await this.setState({Hold: Items});
        }
        await this.setState({
            token: token,
            orderLines: orderLines,
            order: order,
            locations: locations,
            orderLinesCopy: orderLines
        });
        //Getting locally saved data
        var isFound = false;
        if (Items !== null) {
            if (Items.length !== 0) {
                await Items.map(async (item) => {
                    if (item.id === order.id) {
                        if (this.state.module !== 3) {
                            isFound = true;
                            this.setState({orderLines: item.items, loading: false});

                        }
                    }
                });
            } else {
                this.setState({loading: false});
            }
        }
        //If it is not found in Local Storage
        if (!isFound) {
            this.setState({loading: false});
        }
        //If user is packaging
        else if (module === 1) {
            this.setState({loading: false});
        }
        //If user is driver
        else if (module === 2 || module === 3) {
            var temp = [{"product_id": [this.state.order.id, this.state.order.name]}]
            this.setState({orderLines: temp, loading: false});
        }
    }

    compWMS = async () => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        const token = JSON.parse(localStorage.getItem("Token"));
        const orderLines = JSON.parse(localStorage.getItem("TransactionLines"));
        const order = JSON.parse(localStorage.getItem("Transaction"));
        const module = JSON.parse(localStorage.getItem("Interface"));
        const locations = JSON.parse(localStorage.getItem("Locations"));
        const Items = JSON.parse(localStorage.getItem("HoldWMS"));
        await this.getAllCategoryProducts(db);

        //If user is packaging
        if (module === 0) {
            this.setState({title: "Pick & Pack", disableScan: false});
        }
        //If user is driver
        else if (module === 1) {
            this.setState({title: "Packages", stage: "Shipped"});
        }
        //If user is warehouse manager and checking packages
        else if (module === 2) {
            this.setState({title: "Packages", stage: "Landed"});
        }
        //If user is repackaging
        else if (module === 3) {
            this.setState({
                title: "Repackage",
                module: module,
                itemsHeader: [{"name": ""}, {"name": "Barcode"}, {"name": "Name"}, {"name": "Qty"}, {"name": "PackageNb"}]
            });
        }
        if (Items !== null) {
            await this.setState({Hold: Items});
        }
        await this.setState({
            token: token,
            orderLines: orderLines,
            order: order,
            locations: locations,
            orderLinesCopy: orderLines
        });
        await this.setState({fixedName: this.state.order.name + "-"});
        //If transaction is RFQ
        if (this.state.selectedType === 0) {
            this.getCategories(Items);
        }
        //If transaction is transfer
        else {
            this.getOrderLines(Items);
        }
    }

    getAllCategoryProducts = async (db) => {
        const dataArray = [];
        const citiesCol = collection(db, 'AllCategoryProducts');
        const citySnapshot = await getDocs(citiesCol);
        citySnapshot.docs.map(doc => {
            const data = doc.data();
            const documentId = Number(doc.id);
            const documentObj = {id: documentId, ...data};
            dataArray.push(documentObj);
        });
        this.setState({allCategoryProducts: dataArray});
    }

    getOrderLines = async (Items) => {
        //Getting locally saved data
        var temp = [];
        if (Items !== null) {
            if (Items.length !== 0) {
                await Items.map(async (item) => {
                    if (item.id === this.state.order.id) {
                        //If user is scanning packages
                        if (this.state.module !== 3) {
                            this.setState({orderLines: item.items, loading: false});

                        }
                        //If user is repackaging
                        else if (this.state.module === 3) {
                            this.setState({items: item.items});
                            const groups = await this.groupArrayOfObjects(this.state.orderLines, "result_package_id");
                            var items = [];
                            var temp = [];
                            Object.entries(groups).map(([key, value], index) => {
                                items.push(value);
                                temp[index] = {}
                                temp[index].name = key;
                            })
                            this.setState({orderLines: temp, loading: false})
                        }
                    }
                });
            } else {
                this.grouping();
            }
        } else {
            this.grouping();
        }
    }
    //testing Push
    getCategories = async (Items) => {
        //Getting locally saved data
        const ItemsCopy = JSON.parse(localStorage.getItem("StockMovesItems"));
        var temp = [];
        var isFound = false;
        if (Items !== null) {
            if (Items.length !== 0) {
                await Items.map((item) => {
                    if (item.id === this.state.order.id && item.items.length !== 0) {
                        this.setState({
                            items: item.items,
                            packagesCategory: item.packagesCategory,
                            disableScan: false,
                            itemsCopy: ItemsCopy
                        });
                        isFound = true
                    }
                });
                var counters = [];
                await this.state.items.map((object, index) => {
                    if (object !== null) {
                        return object.map(item => {
                            counters.push(item.packageNb);
                        })
                    } else {
                        this.setState({...this.state.items[index] = []});
                    }
                });
                if (isFound) {
                    const max = await Math.max(...counters);
                    this.setState({counter: max, barcode: this.state.fixedName + this.pad(max, 2)});
                }
            }
        }
        await Promise.all(this.state.orderLines.map(async (item) => {
            const categoryURL = constantURI() + "GetCategory?token=" + this.state.token + "&user=" + this.state.username + "&id=" + item.product_id[0] + "&type=" + "consu";
            if (this.state.authenticate) {
                await _post(categoryURL).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined)
                            await temp.push(data.result[0]);
                        else
                            alert("Please try again");
                    })
                })
            } else {
                alert("Please connect to the internet");
            }
        })).then(async () => {
            await this.setState({categories: temp, source: this.state.order.source_location_id[0], loading: false});
            localStorage.setItem("ProductCategories", JSON.stringify(this.state.categories));
        })
    }

    groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    onShow = async (index, type) => {
        await this.setState({
            ...this.state.show[index] = !this.state.show[index],
            specificSelectedType: type[0],
            title: type[1]
        });
        //Show only the selected category and hide the others
        await this.state.show.map((item, itemIndex) => {
            if (itemIndex !== index) {
                this.setState({...this.state.show[itemIndex] = false});
            }
        });
        await this.state.show.map(async (item, itemIndex) => {
            if (item) {
                this.setState({selectedIndex: itemIndex});
                if (this.state.selectedType === 0) {
                    await this.state.allCategoryProducts.map((item) => {
                        if (item.id === this.state.specificSelectedType) {
                            this.setState({productCategory: item.products});
                        }
                    })
                }
            }
        });
        //Focus to scanner
        this.ref.current.focus();
    }

    searchItemWMSPackaging = async () => {
        this.setState({bar: ""});
        //OLD searchItemWMSPackaging ---> NEEDED Folder 

        //Selecting a category is required
        if (this.state.selectedIndex === -1) {
            this.audioWrong.play();
            alert("Please select a category of items");
        } else {
            if (this.state.items[this.state.selectedIndex] === undefined) {
                await this.setState({...this.state.items[this.state.selectedIndex] = []});
            }
            //If the user have reached the limit of ordered quantity
            if (this.state.orderLines[this.state.selectedIndex].product_uom_qty - this.state.items[this.state.selectedIndex].length === 0) {
                this.audioWrong.play();
                alert("You have reached the limit");
                this.ref.current.focus();
            } else {
                var temp = [...this.state.items[this.state.selectedIndex]];
                var isFound = false;
                var isTrue = false;
                var count = 0;
                const item = this.state.productCategory.find(e => e.barcode === this.state.barText);
                if (item) {
                    temp.push(item);
                    isFound = true;
                } else {
                    isFound = false;
                    this.audioWrong.play();
                    alert("This item is not found.")
                    this.ref.current.focus();
                }
                if (isFound) {
                    const finished = await this.removeDuplicateObjectFromArray(temp, "barcode");
                    //Check if item is scanned before
                    if (finished.length === this.state.items[this.state.selectedIndex].length && !isTrue) {
                        this.audioWrong.play();
                        alert("This item is scanned before.");
                        this.ref.current.focus();
                    } else {
                        count++;
                        await finished.map(async (item, index, arr) => {
                            //If the item belongs to the required groups
                            if (index === arr.length - 1) {
                                await this.setState({
                                    ...this.state.items[this.state.selectedIndex] = finished,
                                    ...this.state.items[this.state.selectedIndex][arr.length - 1].packageNb = this.state.counter,
                                    ...this.state.items[this.state.selectedIndex][arr.length - 1].title = this.state.title,
                                });
                                var array = this.state.itemsCopy;
                                var object = {};
                                object.track_status = "1";
                                object.name = item.name;
                                object.product_uom = item.uom_id[0];
                                object.product_id = item.id;
                                object.location_id = this.state.source;
                                object.location_dest_id = this.state.order.dest_location_id[0];
                                object.move_line_ids = [{
                                    location_id: this.state.source,
                                    location_dest_id: this.state.order.dest_location_id[0],
                                    product_uom_qty: item.uom_id[0],
                                    product_uom_id: 1,
                                    product_id: item.id
                                }]
                                array.push(object);
                                this.setState({itemsCopy: array});
                                isTrue = true;
                                var packages = this.state.packagesCategory;
                                if (packages[this.state.counter] === undefined) {
                                    packages[this.state.counter] = [];
                                }
                                const existingTitle = packages[this.state.counter].find(item => item.title === this.state.title);
                                if (existingTitle) {
                                    packages[this.state.counter].map((item) => {
                                        if (item.title === this.state.title) {
                                            item.qty++;
                                        }
                                    })

                                } else {
                                    var secondObject = {};
                                    secondObject.qty = 1;
                                    secondObject.title = this.state.title;
                                    packages[this.state.counter].push(secondObject);
                                }

                                this.setState({packagesCategory: packages});
                            }
                        })
                        //If item doesn't belong to the required groups
                        if (!isTrue) {
                            this.audioWrong.play();
                            alert("This item does not match the groups from the selected category");
                            this.ref.current.focus();
                        }
                    }
                }
            }
        }
    }

    searchItemWMSRepackaging = async () => {
        var isFound = false;
        var isTrue = false;
        //Selecting a category is required
        if (this.state.selectedIndex === -1) {
            this.audioWrong.play();
            alert("Please select a category of items");
        } else {
            //Checking if the scanned item is found,scanned before or not found
            await this.state.items[this.state.selectedIndex].map((item) => {
                if (item.product_id[1].substring(item.product_id[1].indexOf('[') + 1, item.product_id[1].indexOf(']')) === this.state.bar) {
                    if (item.isFound) {
                        this.audioWrong.play();
                        alert("This item is scanned before.");
                    } else {
                        item.isFound = true;
                    }
                    isFound = true;
                    this.setState({bar: ""});
                }
            });
            //If not found add it to the list of products
            if (!isFound) {
                this.audioWrong.play();
                alert("The scanned item does not belong to the selected category. It is going to be added to the category. ");
                var item = {};
                var temp = [...this.state.items[this.state.selectedIndex]];
                var temp2 = [...this.state.addedItems];
                //checking if there is internet connectivity 
                await WMSAuthenticate().then((response) => {
                    this.setState({authenticate: response});
                });
                const getProduct = constantURI() + "GetProduct?token=" + this.state.token + "&user=" + this.state.username + "&code=" + this.state.bar;
                //Search if the scanned item is available
                await _post(getProduct).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            //If available
                            if (data.result[0] !== undefined) {
                                item = data.result[0];
                                item.result_package_id = [];
                                item.isFound = true;
                                item.product_id = [];
                                item.product_uom_qty = data.result[0].qty_available;
                                item.product_id[0] = data.result[0].id;
                                item.product_id[1] = "[" + data.result[0].barcode + "] " + data.result[0].name;
                                item.result_package_id[1] = this.state.orderLines[this.state.selectedIndex].name.substring(this.state.orderLines[this.state.selectedIndex].name.indexOf("FTR"), this.state.orderLines[this.state.selectedIndex].name.length);
                                temp.push(item);
                                temp2.push(item);
                                this.setState({bar: ""});
                            }
                            //If not found
                            else {
                                await this.audioWrong.play();
                                alert("Item not found");
                                this.setState({bar: ""});
                                isTrue = true;
                            }
                        } else {
                            alert("Please try again");
                        }
                    })
                });
                this.setState({...this.state.items[this.state.selectedIndex] = temp, addedItems: temp2, bar: ""});
            }
        }
    }

    searchItemWMSScanning = async () => {
        var isTrue = false;
        //Check if scanned package is found
        await this.state.orderLines.map((item) => {
            if (this.state.bar === item.name.substring(item.name.indexOf("FTR"), item.name.length)) {
                isTrue = true;
                item.isFound = true;
                this.setState({bar: ""});
            }
        });
        if (!isTrue) {
            this.audioWrong.play();
            alert("Package not found");
            await this.setState({bar: ""});
        }
    }

    searchItemOMS = async (module) => {
        var isTrue = false;
        await this.state.orderLines.map((item) => {
            //If user is packagining check if scanned item is equal to one of the ordered items
            if (module === 1) {
                if (this.state.bar === item.product_id[1].substring(item.product_id[1].indexOf("[") + 1, item.product_id[1].indexOf("]"))) {
                    isTrue = true;
                    item.isFound = isTrue;
                    this.setState({bar: ""});
                }
            }
            //If user is scanning packages check if scanned transfer is equal to the specified transfer
            else {
                if (this.state.bar === item.product_id[1]) {
                    isTrue = true;
                    item.isFound = isTrue;
                    this.setState({bar: ""});
                }
            }
        });
        //If item/transfer is not found
        if (!isTrue) {
            var alertString = "";
            if (module === 1)
                alertString = "Item not found";
            else
                alertString = "Transfer not found";

            this.audioWrong.play();
            alert(alertString);
            await this.setState({bar: ""})
        }
    }

    searchItem = async () => {
        //If WMS
        if (this.state.transaction === 0) {
            //If user is packaging
            if (this.state.selectedType === 0) {
                this.searchItemWMSPackaging();
            }
            //If user is scanning packages
            else if (this.state.module !== 3) {
                this.searchItemWMSScanning();
            }
            //If user is repackaging
            else if (this.state.module === 3) {
                this.searchItemWMSRepackaging();
            }
        }

        //If OMS
        else if (this.state.transaction === 1) {
            //If user is packaging
            if (this.state.module === 1) {
                this.searchItemOMS(1);
            }
            //If user is driver
            else if (this.state.module === 2 || this.state.module === 3) {
                this.searchItemOMS(2);
            }
        }
    }

    grouping = async () => {
        const groups = await this.groupArrayOfObjects(this.state.orderLines, "result_package_id");
        var items = [];
        var temp = [];
        Object.entries(groups).map(([key, value], index) => {
            items.push(value);
            temp[index] = {}
            temp[index].name = key;
            temp[index].isFound = false;
        })
        this.setState({orderLines: temp, source: this.state.order.location_id[0], loading: false, items: items});
    }

    removeDuplicateObjectFromArray(array, key) {
        var check = new Set();
        return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
    }

    onHold = async () => {
        var hold = this.state.Hold;
        var temp = {};
        temp.id = await this.state.order.id;
        temp.state = await "Unsynced";
        temp.packagesCategory = await this.state.packagesCategory;
        //If user is packaging
        if (this.state.selectedType === 0) {
            temp.items = await this.state.items;
            await localStorage.setItem("StockMovesItems", JSON.stringify(this.state.itemsCopy));
        } else {
            //If user is repackaging
            if (this.state.module === 3) {
                temp.items = await this.state.items;
            }
            //If user is scanning objects
            else {
                temp.items = await this.state.orderLines;
            }
        }
        const existingOrder = hold.findIndex((item) => item.id === this.state.order.id);
        if (existingOrder !== -1) {
            hold[existingOrder] = temp;
        } else {
            hold.push(temp);
        }
        if (this.state.transaction === 0) {
            await localStorage.setItem("HoldWMS", JSON.stringify(hold));
            //this.props.history.push("/LandingPageWMS");
        } else {
            await localStorage.setItem("HoldOMS", JSON.stringify(hold));
            //this.props.history.push("/LandingPageOMS");
        }
    }

    createPackages = async () => {
        var temp = [];
        for (let i = 0; i < Number(this.state.counter); i++) {
            const createPackage = constantURI() + "CreatePackages?token=" + this.state.token + "&user=" + this.state.username + "&name=" + this.state.fixedName + this.pad((i + 1), 2);
            await _post(createPackage).then((response) => {
                return response.json().then((data2) => {
                    temp.push(data2.result);
                })
            })
            if (i === Number(this.state.counter) - 1) {
                await this.setState({packages: temp});
                await this.createTransfer();
            }
        }
    }

    createTransfer = async () => {
        const createTransfer = constantURI() + "CreateTransfer?token=" + this.state.token + "&user=" + this.state.username + "&type=" + "5" + "&source=" + this.state.source + "&destination=" +
            this.state.order.dest_location_id[0] + "&PO=" + this.state.order.name + "&stage=" + "Packaged";
        var body = {};
        body.lines = this.state.itemsCopy;
        await this.state.itemsCopy.map((item, index, arr) => {
            this.state.items.map((object, index2, arr2) => {
                object.map(async (product, index3, arr3) => {
                    if (product.id === item.product_id) {
                        item.result_package_id = this.state.packages[product.packageNb - 1];
                    }
                })
            })
        });
        console.log(createTransfer);
        console.log(JSON.stringify(body));
        await _postBody(createTransfer, body).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    await this.setState({transferId: data.result});
                    await this.MarkToDo(this.state.transferId);
                } else
                    alert("Please try again");
            })
        });
    }

    onAddPackage = () => {
        this.setState({
            counter: this.state.counter + 1,
            barcode: this.state.fixedName + this.pad(this.state.counter, 2)
        });
        this.ref.current.focus();
    }

    createStockMove = async (item) => {
        const createTransferLines = constantURI() + "CreateTransferMoves?token=" + this.state.token + "&user=" + this.state.username + "&stage=" + "Packaged" + "&productId=" + item.id + "&name=" + item.name +
            "&qty=" + item.qty_available + "&source=" + this.state.source + "&destination=" + this.state.order.location_dest_id[0] + "&transferId=" + this.state.order.id;
        await _post(createTransferLines).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    this.state.items[this.state.selectedIndex].map((object) => {
                        if (object.id === item.id) {
                            object.MarkId = data.result;
                        }
                    })
                    await this.MarkToDo(this.state.order.id);
                    await this.addNewItem(data.result);
                    await this.setState({bar: ""});
                } else {
                    alert("Something went wrong please try again.");
                }
            })
        });
    }

    MarkToDo = async (id) => {
        const markToDo = constantURI() + "Action?token=" + this.state.token + "&user=" + this.state.username + "&action=" + "action_confirm" + "&table=" + "stock.picking" + "&Id=" + id;
        await _post(markToDo).then(async (response) => {
            return await response.json().then((data) => {
                this.checkAvailability();
            });
        });
    }

    checkAvailability = async () => {
        const ckeckAvailability = constantURI() + "Action?token=" + this.state.token + "&user=" + this.state.username + "&action=" + "action_assign" + "&table=" + "stock.picking" + "&Id=" + this.state.transferId;
        await _post(ckeckAvailability).then(async (response) => {
            return await response.json().then(() => {
                if (this.state.module !== 3)
                    this.getMoveLines();
            })
        })
    }

    getMoveLines = async () => {
        const stockMoveLines = constantURI() + "GetTransferLines?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + this.state.transferId;
        await _post(stockMoveLines).then((response) => {
            return response.json().then((data3) => {
                this.setState({SML: data3.result});
            })
        });
        await this.addPackages();
    }

    addNewItem = async (id) => {
        const stockMoveLine = constantURI() + "GetTransferLine?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + this.state.order.id + "&id=" + id;
        await _post(stockMoveLine).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    if (data.result.length !== 0) {
                        this.state.items[this.state.selectedIndex].map((object) => {
                            if (id === object.MarkId) {
                                object.id = data.result[0].id;
                            }
                        })
                        const updateTransferLines = constantURI() + "UpdateTransferLines?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + data.result[0].id + "&packageId=" + this.state.orderLines[this.state.selectedIndex].name.substring(0, this.state.orderLines[this.state.selectedIndex].name.indexOf(",")) + "&remark=" + this.state.remark;
                        await _post(updateTransferLines);
                    }
                } else {
                    alert("Something went wrong please try again.");
                }
            })
        });
    }

    addPackages = async () => {
        await this.state.SML.map((item, index, arr) => {
            this.state.items.map((object, index2, arr2) => {
                object.map(async (product, index3, arr3) => {
                    if (product.id === item.product_id[0]) {
                        const updateTransferLines = constantURI() + "UpdateTransferLines?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + item.id + "&packageId=" + this.state.packages[product.packageNb - 1];
                        await _post(updateTransferLines);
                    }
                    //Emptying locally saved data
                    if (index3 === arr3.length - 1 && index2 === arr2.length - 1 && index === arr.length - 1) {
                        const arr = await this.state.Hold.filter((item) => item.id !== this.state.order.id);
                        if (this.state.transaction === 0) {
                            await localStorage.setItem("HoldWMS", JSON.stringify(arr));
                        } else {
                            await localStorage.setItem("HoldWMS", JSON.stringify(arr));
                        }
                        await localStorage.setItem("StockMovesItems", JSON.stringify([]));
                        await this.props.history.push("/LandingPageWMS");
                    }
                })
            })
        });
    }

    toTravelling = async () => {
        const updateTransfer = constantURI() + "UpdateTransfer?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + this.state.order.id + "&stage=" + this.state.stage;
        await _post(updateTransfer);
        await this.state.orderLinesCopy.map(async (item) => {
            const updateTransferMoves = constantURI() + "UpdateTransferMoves?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + item.MarkId + "&stage=" + this.state.stage;
            await _post(updateTransferMoves);
        });
    }

    checkPackage = async () => {
        var isEmpty = false;
        await this.state.items.map((item) => {
            if (item.length !== 0) {
                isEmpty = true;
            }
        })
        return isEmpty;
    }

    validate = async () => {
        const validate = constantURI() + "Action?token=" + this.state.token + "&user=" + this.state.username + "&action=" + "button_validate" + "&table=" + "stock.picking" + "&Id=" + this.state.order.id;
        await _post(validate);
    }

    createBackOrder = async () => {
        this.validate();
        const createBackup = constantURI() + "CreateImmediateTransfer?token=" + this.state.token + "&user=" + this.state.username + "&date=" + new Date().toISOString().substring(0, 10) + "&transferId=" + this.state.order.id;
        await _post(createBackup).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    const process = constantURI() + "Action?token=" + this.state.token + "&user=" + this.state.username + "&action=" + "process" + "&table=" + "stock.backorder.confirmation" + "&Id=" + data.result;
                    await _post(process);
                } else
                    alert("Please try again");
            })
        })
    }

    savingWMSRepackaging = async () => {
        var isComplete = 0;
        var length = 0;
        var updateTransfer = constantURI() + "UpdateTransfer?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + this.state.order.id + "&stage=";
        await this.state.items.map((item) => {
            length += item.length;
            item.map((item2) => {
                if (item2.isFound === true || item2.status === "5")
                    isComplete++;
            })
        });
        await Promise.all(await this.state.addedItems.map(async (item) => {
            await this.createStockMove(item);
        })).then(async () => {
            //Update transfer moves
            this.state.items.map((item) => {
                item.map((item2) => {
                    if (item2.isFound) {
                        const updateItemStatus = constantURI() + "UpdateTransferMoves?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + item2.MarkId + "&stage=" + "Repackaged";
                        _post(updateItemStatus);
                        const updateItemQty = constantURI() + "UpdateTransferLines?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + item2.id + "&qty=" + item2.product_uom_qty;
                        _post(updateItemQty);
                    }
                })
            })
            //If not all items are scanned
            if (isComplete !== length) {
                updateTransfer = updateTransfer + "Repackaged";
                await _post(updateTransfer);
                await this.createBackOrder();
                const arr = await this.state.Hold.filter((item) => item.id !== this.state.order.id);
                await localStorage.setItem("HoldWMS", JSON.stringify(arr));
                await this.props.history.push("/LandingPageWMS");
            }
            //If all items are scanned
            else {
                updateTransfer = updateTransfer + "Done";
                await _post(updateTransfer);
                await this.validate();
                const arr = await this.state.Hold.filter((item) => item.id !== this.state.order.id);
                await localStorage.setItem("HoldWMS", JSON.stringify(arr));
                await this.props.history.push("/LandingPageWMS");
            }
        })
    }

    onSave = async () => {
        this.setState({disableSave: true});
        this.stopInterval();
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        //If online
        if (this.state.authenticate) {
            //IF WMS
            if (this.state.transaction === 0) {
                //If transaction is RFQ
                if (this.state.selectedType === 0) {
                    if (await this.checkPackage()) {
                        await this.createPackages();
                    } else {
                        this.props.history.push("/LandingPageWMS");
                        this.setState({disableSave: false});
                    }
                }
                //If transaction is transfer
                if (this.state.selectedType === 1) {
                    //if user is scanning packages 
                    if (this.state.module !== 3) {
                        var isComplete = 0;
                        await this.state.orderLines.map((item) => {
                            if (item.isFound === true)
                                isComplete++;
                        });
                        if (isComplete !== this.state.orderLines.length) {
                            alert("Not all required packages are scanned");
                            this.setState({disableSave: false});
                        } else {
                            this.toTravelling();
                            const arr = await this.state.Hold.filter((item) => item.id !== this.state.order.id);
                            await localStorage.setItem("HoldWMS", JSON.stringify(arr));
                            await this.props.history.push("/LandingPageWMS");
                        }
                    }
                    //If user is repackaging
                    else if (this.state.module === 3) {
                        this.savingWMSRepackaging();
                    }
                }
            }
            //If OMS
            else {
                const updateItemStatus = constantURI() + "UpdateSO?token=" + this.state.token + "&user=" + this.state.username + "&SOId=" + this.state.order.id + "&stage=" + this.state.stage;
                await _post(updateItemStatus);
                const arr = await this.state.Hold.filter((item) => item.id !== this.state.order.id);
                await localStorage.setItem("HoldOMS", JSON.stringify(arr));
                await this.props.history.push("/LandingPageOMS");
            }
        }
        //If offline
        else {
            alert("Please connect to the internet.");
            this.setState({disableSave: false});
        }
    }

    pad(n, length) {
        //Formating digits
        var len = length - ('' + n).length;
        return (len > 0 ? new Array(++len).join('0') : '') + n
    }

    onChangeBar = (e) => {
        this.setState({bar: e.target.value, barText: e.target.value});
    }

    onChangeCounter = (e) => {
        this.setState({counter: e.target.value});
        if (e.target.value !== "") {
            this.setState({disableScan: false});
            this.ref.current.focus();
        } else
            this.setState({disableScan: false});
    }

    onChangePackage = (index) => (e) => {
        this.setState({
            ...this.state.items[this.state.selectedIndex][index].packageNb = e.target.value,
            counter: e.target.value
        });
        if (e.target.value !== "")
            this.ref.current.focus();
    }

    closeDeleteAlert = () => {
        this.setState({showDeleteAlert: false})
    }

    showDeleteAlert = (itemIndex) => {
        this.setState({itemIndex: itemIndex});
        this.setState({showDeleteAlert: true});
    }

    closeSourceAlert = () => {
        this.setState({showSourceAlert: false})
    }

    showSourceAlert = () => {
        this.setState({showSourceAlert: true});
    }

    onDeleteItem = () => {
        var transNew = this.state.items[this.state.selectedIndex];
        transNew.splice(this.state.itemIndex, 1);
        this.setState({...this.state.items[this.state.selectedIndex] = transNew});
        this.closeDeleteAlert();
        this.ref.current.focus();
    }

    Header = () => {
        {
            return (
                <div>
                    <div className="row pt-3">
                        <div className="col-3">
                            <ArrowBackCircle className="btn"
                                             onClick={() => this.props.history.push(this.state.transactionType[this.state.selectedType].name + "Detail")}
                                             color={'#00bfff'} height="50px" width="50px"/>
                        </div>
                        <h3 className="little col-4 text-center">{this.state.title}</h3>
                        <div className="col-5 d-flex flex-row-reverse">
                            <div className={(this.state.disableSave) ? "btn disabled" : "btn"}
                                 style={stylesMed.deleteButtonAlert} onClick={() => this.onSave()}>Save
                            </div>
                            <div className={(this.state.disableSave) ? "btn disabled" : "btn"}
                                 style={stylesMed.deleteButtonAlert} onClick={() => this.onHold()}>Hold
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        console.log(this.state.Hold);
        console.log(this.state.items);
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                    {this.Header()}
                    <div className="row mt-4">
                        <div className="col-4">
                            <h5 className="little">Scan Item</h5>
                            <input autoFocus ref={this.ref} className=" form-control"

                                   onKeyDown={(e) => {
                                       if (e.keyCode === 13) {
                                           this.searchItem();
                                       }
                                   }} onChange={(e) => this.onChangeBar(e)}
                                   value={this.state.bar}/>
                        </div>
                        {(this.state.selectedType === 0) ?
                            <div className="col-4">
                                <h5 className="little">Package Number</h5>
                                <span className="little">{this.state.counter}</span>
                                <button className="getorder btn mt-5" onClick={() => this.onAddPackage()}>Next Package
                                </button>
                                {/*<input autoFocus className="col text-center form-control" type="number" style={{ width: "50%" }}*/}
                                {/*    onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"*/}
                                {/*    value={this.state.counter} onChange={(e) => this.onChangeCounter(e)} />*/}
                            </div>
                            : null
                        }
                    </div>
                    {(this.state.selectedType === 0) ?
                        <div className="col d-flex flex-row-reverse"
                             style={(this.state.counter === 1) ? {pointerEvents: "none"} : null}>
                            <ReactToPrint
                                trigger={() => {
                                    return <div className="getorder btn mt-3" href="#">Print Screen</div>;
                                }}
                                content={() => this.componentRef}
                            />
                            <div style={stylesASAP.displayDoc}>
                                <DeliveryForm
                                    ref={el => (this.componentRef = el)}
                                    barcode={this.state.barcode}
                                    from={this.state.order.source_location_id[1]}
                                    to={this.state.order.dest_location_id[1]}
                                    category={this.state.packagesCategory}
                                    currentPackage={(this.state.counter - 1)}
                                />
                            </div>
                        </div>
                        : null}
                    {this.state.orderLines.map((item, index) => {
                        return (
                            <div className="pt-4 " style={stylesMed.mainBackgroundColor} key={index}>
                                {(this.state.selectedType === 0) ?
                                    (!this.state.show[index]) ?
                                        <div
                                            className={(this.state.disableScan) ? "btn bg-light disabled" : "btn bg-light"}
                                            style={stylesMed.dailyCard}
                                            onClick={() => this.onShow(index, item.product_id)}>
                                            <div className="row">
                                                <ArrowForwardCircle className="col-1 pt-2 d-flex justify-content-start"
                                                                    color={'#00bfff'} height="35px" width="35px"/>
                                                <p className="little col-6 pt-2 d-flex justify-content-start">
                                                    <b>{item.product_id[1].substring((item.product_id[1].indexOf("]") + 1))}</b>
                                                </p>
                                                <p className="little col-5 pt-2 d-flex justify-content-start">Remaining
                                                    Qty:<b>{(this.state.items[index] !== undefined) ? item.product_uom_qty - this.state.items[index].length : item.product_uom_qty}</b>
                                                </p>
                                            </div>
                                        </div> :
                                        <div className="btn bg-secondary" style={stylesMed.dailyCard}
                                             onClick={() => this.onShow(index, item.product_id)}>
                                            <div className="row">
                                                <ArrowDownCircle className="col-1 pt-2 d-flex justify-content-start"
                                                                 color={'#00bfff'} height="35px" width="35px"/>
                                                <p className="little col-6 pt-2 d-flex justify-content-start">
                                                    <b>{item.product_id[1].substring((item.product_id[1].indexOf("]") + 1))}</b>
                                                </p>
                                                <p className="little col-5 pt-2 d-flex justify-content-start">Remaining
                                                    Qty:<b>{(this.state.items[index] !== undefined) ? item.product_uom_qty - this.state.items[index].length : item.product_uom_qty}</b>
                                                </p>
                                            </div>
                                        </div>
                                    :
                                    <div className={(!item.isFound) ? "bg-light p-2" : "bg-success p-2"}
                                         style={stylesMed.dailyCard}
                                         onClick={(this.state.module === 3) ? () => this.onShow(index, 0) : null}>
                                        <div className="row">
                                            <p className={(this.state.transaction === 0) ? "col-4 pt-2 d-flex justify-content-start" : "col pt-2 d-flex justify-content-start"}>
                                                <b>{(this.state.transaction === 0) ? item.name.substring(item.name.indexOf("FTR"), item.name.length) : item.product_id[1]}</b>
                                            </p>
                                        </div>
                                    </div>
                                }
                                {(this.state.items[index] !== undefined && this.state.show[index]) ?
                                    <div style={stylesWMS.scroll}>
                                        <div className="row mt-3" key={index}>
                                            {this.state.itemsHeader.map((item, index) => {
                                                return (
                                                    <h5 className="col-2 little text-center"
                                                        key={index}>{item.name}</h5>
                                                )
                                            })}
                                        </div>
                                        <hr/>
                                        {this.state.items[index].map((product, productIndex) => {
                                            return (
                                                <div>
                                                    <div className="row mt-3" key={index}>
                                                        {(this.state.module === 3) ?
                                                            <div className="col-2 little text-center">
                                                                {(product.isFound || product.status === "5") ?
                                                                    < FaCheck style={{
                                                                        color: "green",
                                                                        width: 50,
                                                                        height: 50
                                                                    }}/>
                                                                    :
                                                                    <p></p>
                                                                }
                                                            </div>
                                                            : null
                                                        }
                                                        <p className="col-2 little text-center">{(product.barcode === undefined) ? product.product_id[1].substring(product.product_id[1].indexOf('[') + 1, product.product_id[1].indexOf(']')) : product.barcode}</p>
                                                        <p className="col-2 little text-center">{(product.name === undefined) ? product.product_id[1].substring(product.product_id[1].indexOf(']') + 1) : product.name}</p>
                                                        <p className="col-2 little text-center">1</p>
                                                        {(this.state.module === 3) ?
                                                            <p className="col-2 little text-center">{product.result_package_id[1]}</p>
                                                            :
                                                            <p className="col-2 little text-center">{this.state.fixedName + this.pad((product.packageNb), 2)}</p>
                                                            //<div><input className="col text-center form-control" type="number" style={stylesWMS.inputTable}
                                                            //    onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                                            //    value={product.packageNb} onChange={this.onChangePackage(productIndex)} />
                                                            //</div>
                                                        }
                                                        {(this.state.module === 3) ?
                                                            null :
                                                            <TrashOutline className="col-2  btn" color={'#00bfff'}
                                                                          height="30px" width="30px"
                                                                          onClick={() => this.showDeleteAlert(productIndex)}/>
                                                        }
                                                    </div>
                                                    <hr/>
                                                </div>
                                            )
                                        })
                                        }
                                    </div>
                                    : null
                                }
                            </div>
                        )
                    })}
                    <Modal show={this.state.showDeleteAlert} onHide={this.closeDeleteAlert} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Are you sure you want to delete this transfer?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="btn btn-primary" style={stylesWMS.deleteButtonAlertTransfer}
                                 onClick={() => this.onDeleteItem()}>Delete
                            </div>
                            <div className="btn btn-danger" style={stylesWMS.cancelButtonAlertTransfer}
                                 onClick={() => this.closeDeleteAlert()}>Cancel
                            </div>
                        </Modal.Body>
                    </Modal>
                    {/*<Modal show={this.state.showSourceAlert} onHide={this.closeSourceAlert} animation={false}>*/}
                    {/*    <Modal.Header>*/}
                    {/*        <Modal.Title>Chosse a source location?</Modal.Title>*/}
                    {/*    </Modal.Header>*/}
                    {/*    <Modal.Body>*/}
                    {/*        <select className="form-control mb-4" id="sel1" value={this.state.source} onChange={this.onChangeSource}*/}
                    {/*            name="sellist1" style={stylesWMS.datelocation}>*/}
                    {/*            <option value=""></option>*/}
                    {/*            {this.state.locations.map((item, index) => {*/}
                    {/*                return (*/}
                    {/*                    <option key={index} value={item.id}>{item.complete_name}</option>*/}
                    {/*                )*/}
                    {/*            })*/}
                    {/*            }*/}
                    {/*        </select>*/}
                    {/*        <div className={(this.state.disableSave) ? "btn btn-primary disabled" : "btn btn-primary"} style={stylesWMS.deleteButtonAlertTransfer} onClick={() => this.onSave()}>Save</div>*/}
                    {/*        <div className="btn btn-danger" style={stylesWMS.cancelButtonAlertTransfer} onClick={() => this.closeSourceAlert()}>Cancel</div>*/}
                    {/*    </Modal.Body>*/}
                    {/*</Modal>*/}
                </div>
            );
        } else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {this.Header()}
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }

    }
}
